module.exports = __webpack_public_path__ + "8d945071.png";